require('./loanPartialAmortizationView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText } = require('core/i18n').i18n;
const { withRouter } = require("react-router-dom");
const { connect } = require('react-redux');
// @ helpers
const { toCamelCase } = require('utilities/stringHelper');
// @ components
const LoanHeader = require('../../components/loansAndMortgages/loans/loanHeader/loanHeader');
const { LoanPartialAmortizationWizard } = require('../../components/loansAndMortgages/loanPartialAmortization/loanPartialAmortizationWizard/loanPartialAmortizationWizard');

class LoanPartialAmortizationView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    buildBreadcrum(immLoan) {
        const root = {
            text: formatText('breadcrumb-loansAndMortgages'),
            url: `/myprofile/loans-mortgages`
        };

        return immLoan ? [
            root,
            {
                text: immLoan.get('alias'),
                url: `/myprofile/loans-mortgages/loans/${immLoan.get('loanId')}`
            },
            {
                text: formatText('breadcrumb-partialAmortization')
            }
        ] : [root];
    }

    buildProductName(immLoan) {
        let name = ' ';

        if (immLoan) {
            name = immLoan.get('isAliasUpdating') ? toCamelCase(immLoan.get('aliasTentative')) : toCamelCase(immLoan.get('alias'));
            name = `${formatText('loanPartialAmortization-title')} ${name}`;
        }

        return name;
    }

    buildHeader(title) {
        const { match: {params: { loanId }}, immLoans } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);
        const breadcrumb = this.buildBreadcrum(immLoan);

        return (
            <LoanHeader
                immLoan={immLoan}
                breadcrumbConfig={breadcrumb}
                title={title}
                showDetails={false}
            />
        );
    }

    handleCancel() {
        this.props.history.push('/myprofile/global');
    }

    render() {
        const { match: {params: { loanId }}, immLoans ,immFlagBasedFeatures} = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);
        const productName = this.buildProductName(immLoan);
        const header = this.buildHeader(productName)

        return (
            <div className="loan-partial-amortization-view">
                {header}
                <div className="loan-partial-amortization-view__body">
                    <LoanPartialAmortizationWizard
                        immLoan={immLoan}
                        onCancel={this.handleCancel}
                        productName={productName}
                        immFlagBasedFeatures={immFlagBasedFeatures}

                />
                </div>
            </div>
        );
    }
}

LoanPartialAmortizationView.propTypes = {
    immLoans: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = LoanPartialAmortizationView;
module.exports = withRouter(connect(
    state => ({
        immLoans: state.loans,
        immFlagBasedFeatures: state.flagBasedFeatures,

    }), {}
)(LoanPartialAmortizationView));
